/*
 * @ Author: wangjiyu
 * @Date: 2019-10-31 16:11:14
 * @LastEditTime: 2019-10-31 17:01:59
 * @LastEditors: wangjiyu
 * @Description: file content
 */
import ajax from '@/util/ajax';
import commonUtil from '@/util/common';
import Message from '@/component/message';

export interface ErrorObject {
    throwError: boolean;
    showErrorMessage: boolean;
    callback: (e: any) => void | null;
}
export interface ServiceOption {
    headers?: object;
    throwError?: boolean;
    callback?: (e: any) => void | null;
}
export default {
    async serviceAjax(
        url: string,
        type: string,
        reqData: object = {},
        option: ServiceOption = {
            headers: {},
            throwError: true
        }
    ) {
        let success = true;
        let error = null;
        let data: any = {};
        let pagination;
        let code;
        let msg;
        try {
            const { response } = await ajax[type](url, reqData, option.headers);

            code = response.code;
            msg = response.msg;

            if (response.data) {
                data = response.data;
                pagination = response.pagination;
            }

            if (response.code && response.code !== 0) {
                data = null;
                success = false;
                if (response.msg && option.throwError) {
                    Message.error(response.msg);
                }
            }
        } catch (e) {
            error = e;
            data = null;
            success = false;
            if (typeof option.callback === 'function') {
                option.callback(e);
            }
            if (option.throwError) {
                commonUtil.throwError(e);
            }
        }
        return {
            success,
            error,
            pagination,
            data,
            code,
            msg
        };
    }
};
